import { datadogRum } from "@datadog/browser-rum";

/**
 * Initialize Datadog RUM (Real User Monitoring)
 * Monitors frontend performance, errors, and user sessions for JoyIA
 */
export function initDatadog() {
  const applicationId = import.meta.env.VITE_DATADOG_RUM_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DATADOG_RUM_CLIENT_TOKEN;
  const env = import.meta.env.VITE_DATADOG_ENV || import.meta.env.MODE || "dev";
  const service = import.meta.env.VITE_DATADOG_SERVICE || "joyia-tribes";
  // UST version, supplied by infra alongside env and service. Without it every RUM
  // session reported no version, so a regression could not be tied to a deploy.
  const version = import.meta.env.VITE_DATADOG_VERSION;

  // Only initialize if credentials are available
  if (!applicationId || !clientToken) {
    console.warn("Datadog RUM credentials not found, skipping initialization");
    return;
  }

  try {
    datadogRum.init({
      applicationId,
      clientToken,
      site: "datadoghq.eu",
      service,
      env,
      ...(version ? { version } : {}),
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: "mask-user-input",
    });

    console.log(`Datadog RUM initialized for ${service} (${env})`);
  } catch (error) {
    console.error("Failed to initialize Datadog RUM:", error);
  }
}
